document.addEventListener('turbolinks:load', () => {
  $('#voucher_package_ids').select2();
});
